module.exports = __webpack_public_path__ + "assets/img/folast.8a948d3e.jpg";